import { addCommas, obtenerData } from '../js/utils.js'

//Materialize
import '../stylus/vista.styl'

//FontAwsome
import '../libs/fontawesome/css/brands.min.css'

let itemAnim 	= null
,	timerRev 	= null
,	map 		= null
,	_loaded 	= false
,	dataJS 		= null
,	esAnim 		= null
,	tipoVista 	= null
,	initAnim 	= 0
,	cantAnim 	= null
,	centerMap	= null
$(document).ready(function() { 	
	// 

	obtenerData(slugVista, keyVista, function(data){
		if(data.status !== true){
			M.toast({html: 'Ocurrió un error durante la recuperación de la información'})
			return;
		}
		console.log(data)
		
		esAnim 		= data.vista.esAnim == 1;
		tipoVista 	= data.vista.tipoVista

		switch(tipoVista){
			// Mapa de calor
			case '2':				
				pintarMapa(data.cantAnim, data.dataJS, data.center);
				break;

			// Gráfico de barras
			// Gráfico de línea
			// Gráfico de radar
			// Gráfico de torta
			// Gráfico polar
			// Gráfico de rosquilla
			case '4':
			case '5':
			case '7':
			case '6':
			case '8':
			case '9':
				const chartData = {labels: data.dataJS[0].labels, datasets: data.dataJS[0].datasets}
				,	chartConfig = {
						type: data.vista.tiposVistaHomolog,
						data: chartData,
						options: {
							elements: {
								bar: {
									borderWidth: 2,
								}
							},
							responsive: true,
							plugins: {
								legend: {
									position: 'top',
								},
								title: {
									display: true,
									text: data.vista.nameVista
								}
							}
						},
					}
				,	$canvas		= $('#chart-data canvas')
				,	ctx  		= $canvas.get(0).getContext("2d")
				,	myChart  	= new Chart(ctx, chartConfig);
				break;

			default:
				console.log(data.data)
				$('#table-data').empty()
				pintarTabla($('#table-data'), data.data[0].headers, data.data[0].data);
		}

	})


	$('#ctl_play').on('click', function(event){
		event.stopPropagation()
		event.preventDefault()
		iniciarAnimacion()
	})

	$('#ctl_stop').on('click', function(event){
		event.stopPropagation()
		event.preventDefault()
		stopAnimacion()
	})

	$('#ctl_rages').on('mouseup', function(event){
		itemAnim = $(this).val()
	})

})

function iniciarAnimacion(){
	if(timerRev != null) return;
	$('#ctl_play').addClass('pressed')
	itemAnim = initAnim
	timerRev = setInterval(function(){
		if(!_loaded) return;
		if(itemAnim >= cantAnim || dataJS[itemAnim + 1] == undefined){
			stopAnimacion()
			return;
		}		
		itemAnim 	= itemAnim + 1;
		$('#ctl_rages').val(itemAnim)
		$('.controllers .label').text(dataJS[itemAnim].label)
		map.getSource('custom-points').setData(dataJS[itemAnim].markers);
		// map.panTo(dataJS[itemAnim].center);
	}, 200);
}

function stopAnimacion(){	
	if(timerRev == null) return;
	$('#ctl_play').removeClass('pressed')
	clearInterval(timerRev);
	timerRev = null
	itemAnim = initAnim
}

function pintarTabla($where, header, data){
	let $table 	= $('<table />').appendTo($where)
	,	$thead 	= $('<thead />').appendTo($table)
	,	$tbody 	= $('<tbody />').appendTo($table)

	let $trHead = $('<tr />').appendTo($thead)
	for(let i in header){
		$trHead.append(`<th>${header[i]}</th>`)
	}

	for(let fila in data){
		let $trFila = $('<tr />').appendTo($tbody)
		for(let columna in data[fila]){
			$trFila.append(`<td>${data[fila][columna]}</td>`)
		}
	}


}

function pintarMapa(setCantAnim, setDataJS, setCenterMap){
	if($('#map').length == 0) return;
	if($('#map.iniciado').length == 1) return;

	cantAnim 	= setCantAnim;
	dataJS 		= setDataJS
	centerMap	= setCenterMap;

	let elements 		= $('#bigheader').outerHeight(true) + $('#bigbreadcrumbs').outerHeight(true) + $('#bigfooter').outerHeight(true) + $('#bigcontainer').outerHeight(true)
	,	realHeight 		= $(window).outerHeight(true) - elements
	$('#map').height(realHeight);
	
	
	$('#map').addClass('iniciado')
	$('#ctl_rages').attr({min: initAnim, max: cantAnim}).val(0)
	$('.controllers').css('display', esAnim ? 'flex' : 'none')

	mapboxgl.accessToken = 'pk.eyJ1Ijoic3J1ZWRhIiwiYSI6ImNsNnV3cjhneDBuZTMzZHA1NmloYWZzbGIifQ.UnmbWc-FJbmwlgfFDg7BKw';
	map  	= new mapboxgl.Map({
 							container:  	'map',
 							style:  		'mapbox://styles/mapbox/streets-v11',
 							center:  		centerMap,
 							zoom:  			esAnim ? 12 : 13,
						});


	map.on('load', () => {
		map.addSource('custom-points', {
			'type': 'geojson',
			'data': dataJS[0].markers
		});
		map.addLayer({
				'id': 'trees-heat',
				'type': 'heatmap',
				'source': 'custom-points',
				'maxzoom': 15,
				'paint': {
					// increase weight as diameter breast height increases
					'heatmap-weight': {
						'property': 'value',
						'type': 'exponential',
						'stops': [
							[1, 0],
							[100, 1]
						]
					},
					// increase intensity as zoom level increases
					'heatmap-intensity': {
						'stops': [
							[11, 1],
							[15, 3]
						]
					},
					// use sequential color palette to use exponentially as the weight increases
					'heatmap-color': [
						'interpolate',
						['linear'],
						['heatmap-density'],
						0,
						'rgba(16, 52, 166, 0)',
						0.2,
						'rgba(26,255,26,.8)',
						0.4,
						'rgba(234,255,0,.8)',
						0.6,
						'rgba(255,191,0,.8)',
						0.8,
						'rgba(255, 64, 0,.8)',
						0.9,
						'rgba(246,45,45,.9)'
					],
					// increase radius as zoom increases
					'heatmap-radius': {
						'stops': [
							[11, 15],
							[15, 20]
						]
					},
					// decrease opacity to transition into the circle layer
					'heatmap-opacity': {
						'default': .9,
						'stops': [
							[14, .9],
							[15, 0]
						]
					}
				}
			},
			'waterway-label'
		);
 
		map.addLayer({
			'id': 'circle-dots-sr',
			'type': 'circle',
			'source': 'custom-points',
			'minzoom': 14,
			'paint': {
				// increase the radius of the circle as the zoom level and value value increases
				'circle-radius': {
				'property': 'value',
				'type': 'exponential',
					'stops': [
						[{ zoom: 15, value: 0 }, 5],
						[{ zoom: 15, value: 100 }, 10],
						[{ zoom: 22, value: 0 }, 20],
						[{ zoom: 22, value: 100 }, 50]
					]
				},
				'circle-color': {
				'property': 'value',
				'type': 'exponential',
					'stops': [
						[5, 'rgba(26,255,26,.9)'],
						[25, 'rgba(234,255,0,.9)'],
						[55, 'rgba(255,191,0,.9)'],
						[75, 'rgba(255, 64, 0,.9)'],
						[95, 'rgba(246,45,45,.9)'],
					]
				},
				'circle-stroke-color': 'white',
				'circle-stroke-width': 0,
				'circle-opacity': {
					'stops': [
						[10, 0],
						[14, 1]
					]
				}
			}
			},
			'waterway-label'
		);

		_loaded = true;
	});
	// click on tree to view dbh in a popup
	map.on('click', 'circle-dots-sr', (event) => {
		new mapboxgl.Popup()
		.setLngLat(event.features[0].geometry.coordinates)
		.setHTML(`<strong>${event.features[0].properties.yTag}:</strong> ${addCommas(Math.round(event.features[0].properties.vTag))}`)
		.addTo(map);
	});



}


// WEBPACK FOOTER //
// ./src/js/vista.js